import { render, staticRenderFns } from "./UserSettingsRootPage.vue?vue&type=template&id=fc3d9cec&"
import script from "./UserSettingsRootPage.vue?vue&type=script&lang=js&"
export * from "./UserSettingsRootPage.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsRootPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports